export class Projeto {
    idProjeto: number;
    nome: string;
    idContrato: number;
    urlImagemLogo: string;
}
